module.exports = __webpack_public_path__ + "0608b4df00cf1a38005a230c2f9cdadd.jpg";